import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton, Typography } from '@mui/material';

interface CloseableDialogTitleProps {
  title: string;
  handleClose: () => void;
}

const CloseableDialogTitle = ({
  title,
  handleClose,
}: CloseableDialogTitleProps) => {
  return (
    <DialogTitle
      sx={{
        width: '600px',
        boxSizing: 'border-box',
      }}
    >
      <Typography component="div" variant="titleLarge">
        {title}
      </Typography>
      <IconButton
        aria-label="close form dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute !important',
          right: '16px',
          top: '12px',
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default CloseableDialogTitle;
